let eventDelayActive = false;

export const setEventDelayActive = (isEventDelayActive: boolean) => {
	eventDelayActive = isEventDelayActive;
};

export const isEventDelayActive = (): boolean => eventDelayActive;
